/**
 * @module Theme
 */

import { Component, Input } from '@angular/core';
import { ThemeOptionsClass } from '@class/themeOptions.class';
import { ItemColor } from '@functions/item.functions';
import { ThemeOptionType } from '@models/themeStudio.model';

@Component({
  selector: 'app-theme-option-elements-chart-gauge-pointer-stroke-line-cap',
  templateUrl: './theme-option-elements-chart-gauge-pointer-stroke-line-cap.component.html',
  styleUrls: ['./theme-option-elements-chart-gauge-pointer-stroke-line-cap.component.css']
})
export class ThemeOptionElementsChartGaugePointerStrokeLineCapComponent {

  @Input() themeOptions: ThemeOptionsClass;

  color = ItemColor('themes');
  optionType: ThemeOptionType = 'elements_chart_gauge_pointer_stroke_line_cap';

  constructor() {}

  onValue(value: string) {
    this.themeOptions.setOption(this.optionType, value);
  }

  values = {
    butt: { style: 'butt', label: 'BUTT' },
    round: { style: 'round', label: 'ROUND' },
    square: { style: 'square', label: 'SQUARE' }
  };

}